/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：VUEルート
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/19 ノア）黄
 *
 */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import { changeCheck, roleCheck, cookieCheck } from './beforeEach'

Vue.use(VueRouter)

import config from '@/config/config'
import Login from '@/views/login/Login.vue'
import Home from '@/views/home/Home.vue'
import MST_GPS_TRACKER from '@/views/master/MST_GPS_TRACKER.vue'
import MST_AREA from '@/views/master/MST_AREA.vue'
import MST_PREF_ALLOC from '@/views/master/MST_PREF_ALLOC.vue'
import MST_SALES_OFC from '@/views/master/MST_SALES_OFC.vue'
import MST_MGMT_TRGTS from '@/views/master/MST_MGMT_TRGTS.vue'
import MST_MGMT_TRGTS_ALLOC from '@/views/master/MST_MGMT_TRGTS_ALLOC.vue'
import MST_SALES_OFC_ALLOC from '@/views/master/MST_SALES_OFC_ALLOC/MST_SALES_OFC_ALLOC.vue'
import OP_PERF_MVMT from '@/views/operationalPerformance/OP_PERF_MVMT.vue'
import OP_PERF_OFC from '@/views/operationalPerformance/OP_PERF_OFC.vue'
import OP_PERF_AREA from '@/views/operationalPerformance/OP_PERF_AREA.vue'
import CHART_AREA from '@/views/operationalPerformance/CHART_AREA.vue'
import CHART_PREFECTURE from '@/views/operationalPerformance/CHART_PREFECTURE.vue'
import OP_PERF_TRGTS from '@/views/operationalPerformance/OP_PERF_TRGTS.vue'
import MST_USER from '@/views/master/MST_USER.vue'
import MST_TRACTOR_HEAD from '@/views/master/MST_TRACTOR_HEAD.vue'
import MST_AVL_TRACTOR_HEAD from '@/views/master/MST_AVL_TRACTOR_HEAD.vue'
import MST_MGMT_LOC from '@/views/master/MST_MGMT_LOC.vue'
import MST_MGMT_LOC_DTLS from '@/views/master/MST_MGMT_LOC_DTLS.vue'
import MGMT_TRGTS from '@/views/managementTarget/MGMT_TRGTS.vue'
import MST_GPS_TRK_SET from '@/views/master/MST_GPS_TRK_SET.vue'
import MST_CO_MGMT from '@/views/master/MST_CO_MGMT.vue'
import TTIMAP from '@/views/map/MAP.vue'
import MAP_LOCUS from '@/views/map/MAP_LOCUS.vue'
import ALARM from '@/views/managementTarget/ALARM.vue'
import ALERT_LIST from '@/views/managementTarget/ALERT_LIST.vue'
import MST_GPS_TRK_EXCHANGE from '@/views/master/MST_GPS_TRK_EXCHANGE.vue'

import COMPANY_HOME from '@/views/companyEditTool/COMPANY_HOME.vue'
import TOOL_COMPANY_MASTER from '@/views/companyEditTool/TOOL_COMPANY_MASTER.vue'
import TOOL_COMPANY_ADD_EDIT from '@/views/companyEditTool/TOOL_COMPANY_ADD_EDIT.vue'
import TOOL_USER_INFO from '@/views/companyEditTool/TOOL_USER_INFO.vue'
import TOOL_ANNOUNCEMENTS_INFO from '@/views/companyEditTool/TOOL_ANNOUNCEMENTS_INFO.vue'
import TOOL_MANAGEMENT_TARGET_MASTER from '@/views/companyEditTool/TOOL_MANAGEMENT_TARGET_MASTER.vue'
import TOOL_MANAGEMENT_REGISTER from '@/views/companyEditTool/TOOL_MANAGEMENT_REGISTER.vue'
import TOOL_DATA_RECOVERY from '@/views/companyEditTool/TOOL_DATA_RECOVERY.vue'
import TOOL_SIGFOX_INFO from '@/views/companyEditTool/TOOL_SIGFOX_INFO.vue'
import { recordCurrentPage } from '@/service/refreshAndCloseWindowService'
import MST_CONNECT_COMPANY from '@/views/master/MST_CONNECT_COMPANY.vue'
import TOOL_COMPANY_OPTION_SET from '@/views/companyEditTool/TOOL_COMPANY_OPTION_SET.vue'

/**
 * ルート定義
 */
const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Login
  },
  {
    path: '*',
    redirect: '/'
  },
  {
    path: config.menu.login,
    component: Login
  }
]

const routesITP: Array<RouteConfig> = [
  {
    path: config.menu.home,
    component: Home,
    children: [
      {
        path: config.menu.dynamicMap, // 動態地図
        component: TTIMAP
      },
      {
        path: config.menu.locusDisplay, // 軌跡表示
        component: MAP_LOCUS
      },
      {
        path: config.menu.managementList, // 管理対象一覧
        component: MGMT_TRGTS
      },
      {
        path: config.menu.alarmList, // アラーム一覧
        component: ALARM
      },
      {
        path: config.menu.historyManagement, // 移動履歴管理表
        component: OP_PERF_MVMT
      },
      {
        path: config.menu.analysisByBusinessOffices, // 営業所別分析
        component: OP_PERF_OFC
      },
      {
        path: config.menu.areaAnalysis, // エリア分析
        component: OP_PERF_AREA
      },
      {
        path: config.menu.chartArea, // グラフ表示(エリア別)
        component: CHART_AREA
      },
      {
        path: config.menu.chartPrefecture, // グラフ表示(都道府県別)
        component: CHART_PREFECTURE
      },
      {
        path: config.menu.analysisByManagementObject, // 管理対象分析
        component: OP_PERF_TRGTS
      },
      {
        path: config.menu.gpsTrackeraster, // GPSトラッカーマスタ
        component: MST_GPS_TRACKER
      },
      {
        path: config.menu.areaMaster, //エリア登録マスタ
        component: MST_AREA
      },
      {
        path: config.menu.areaAllocation, //エリア割当マスタ
        component: MST_PREF_ALLOC
      },
      {
        path: config.menu.businessOfficeMaster, //営業所登録マスタ
        component: MST_SALES_OFC
      },
      {
        path: config.menu.subjectMaster, // 管理対象マスタ
        component: MST_MGMT_TRGTS
      },
      {
        path: config.menu.subjectMasterAllocation, // 管理対象割当
        component: MST_MGMT_TRGTS_ALLOC
      },
      {
        path: config.menu.businessOfficeAllocation, //営業所割当マスタ
        component: MST_SALES_OFC_ALLOC
      },
      {
        path: config.menu.userMaster, //ユーザマスタ
        component: MST_USER
      },
      {
        path: config.menu.headMaster, // トラクターヘッドマスタ
        component: MST_TRACTOR_HEAD
      },
      {
        path: config.menu.tractorHeadMaster, // 連結可能トラクターヘッドマスタ
        component: MST_AVL_TRACTOR_HEAD
      },
      {
        path: config.menu.managementLocationMaster, // 管理場所登録マスタ
        component: MST_MGMT_LOC
      },
      {
        path: config.menu.managementLocationDetailMaster, // 管理場所詳細登録マスタ
        component: MST_MGMT_LOC_DTLS
      },
      {
        path: config.menu.gpsTrackerTerminalConfig, // GPSトラッカー端末判定値設定
        component: MST_GPS_TRK_SET
      },
      {
        path: config.menu.corporateManagement, // 会社管理
        component: MST_CO_MGMT
      },
      {
        path: config.menu.alertList, // アラートリスト
        component: ALERT_LIST
      },
      {
        path: config.menu.gpsTrackerExchange, // バッテリー交換
        component: MST_GPS_TRK_EXCHANGE
      },
      {
        path: config.menu.connectCompanyMaster, // 連携会社登録マスタ
        component: MST_CONNECT_COMPANY
      }
    ]
  }
]

const routesTool: Array<RouteConfig> = [
  {
    path: config.toolMenu.companyHome,
    component: COMPANY_HOME,
    children: [
      {
        path: config.toolMenu.companyInfo, // 会社情報一覧
        component: TOOL_COMPANY_MASTER
      },
      {
        path: config.toolMenu.companyInfoAddEdit, // 会社情報新規登録、編集
        component: TOOL_COMPANY_ADD_EDIT
      },
      {
        path: config.toolMenu.companyInfoOpSet, // オプション機能設定
        component: TOOL_COMPANY_OPTION_SET
      },
      {
        path: config.toolMenu.userInfo, // ユーザ一覧
        component: TOOL_USER_INFO
      },
      {
        path: config.toolMenu.announcementInfo, // お知らせ
        component: TOOL_ANNOUNCEMENTS_INFO
      },
      {
        path: config.toolMenu.companyManagementTarget, // 管理対象一覧
        component: TOOL_MANAGEMENT_TARGET_MASTER
      },
      {
        path: config.toolMenu.companyManagementRegister, // 会社登録ユーザ一覧
        component: TOOL_MANAGEMENT_REGISTER
      },
      {
        path: config.toolMenu.companyDataRecovery, // データ復旧
        component: TOOL_DATA_RECOVERY
      },
      {
        path: config.toolMenu.companySigfoxInfo, // 端末情報
        component: TOOL_SIGFOX_INFO
      }
    ]
  }
]

const allRoutes: Array<RouteConfig> = routes.concat(routesITP, routesTool) as RouteConfig[]

/**
 * ルートインスタント
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: allRoutes
})

router.beforeEach(cookieCheck)
router.beforeEach(roleCheck)
router.beforeEach(changeCheck)
recordCurrentPage(router)

export default router
